import { Component, Input, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FridgeService } from 'src/app/services/fridge/fridge.service';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification/notification.service';

@Component({
  selector: 'app-fridge-picker-modal',
  templateUrl: './fridge-picker-modal.component.html',
  styleUrls: ['./fridge-picker-modal.component.scss'],
  standalone: false,
})
export class FridgePickerModalComponent {
  modalController = inject(ModalController);
  fridgeService = inject(FridgeService);
  router = inject(Router);
  notificationService = inject(NotificationService);

  @Input() productId: string = '';
  @Input() type: 'weighting' | 'recording';

  async back() {
    await this.modalController.dismiss();
  }

  async open(fridgeId) {
    if (
      await this.fridgeService.checkLabelingState(fridgeId, this.productId, this.type, true, true)
    ) {
      await this.router.navigate([this.type, fridgeId, this.productId]);
      await this.back();
    }
  }
}
